var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"InvestorLog"},[_c('HomeNav'),_vm._v(" "),_c('PhoneNav'),_vm._v(" "),_c('ContentBanner',{attrs:{"BannerList":_vm.BannerList}}),_vm._v(" "),_c('CrumbsNav',{attrs:{"crumbsnav":_vm.crumbsnav}}),_vm._v(" "),_c('FinancialReports',{attrs:{"reportList":_vm.InvestorList}}),_vm._v(" "),_c('BottomNav')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b498f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/investor/InvestoLog.vue
// module id = null
// module chunks = 